import { styled } from '@mui/material';

import { Link } from 'react-router-dom';

import IconCommon from '../../../../Common/Icon';

export const Icon = styled(IconCommon)`
  margin: var(--spacing-medium) auto var(--spacing-medium) var(--spacing-big);
`;

export const StyledLink = styled(Link)`
  display: flex;
`;
